const faqs = [
  {
    q: '91免费视频网站真的完全免费吗？',
    a: '是的，91免费视频网站所有内容均免费提供在线观看，无需付费注册或订阅会员。我们坚持免费视频网站在线观看的初心，让每一位用户都能无障碍享受高清视频资源。',
  },
  {
    q: '视频播放时卡顿怎么办？',
    a: '91在线观看视频网站采用智能CDN加速技术，自动为您匹配最优节点。如遇卡顿，可尝试切换清晰度或检查本地网络。我们持续优化高清视频不缓冲的观看体验，确保流畅播放。',
  },
  {
    q: '支持哪些设备观看？',
    a: '91免费视频网站全面适配PC端、平板和手机端，无论使用电脑、iPhone还是安卓手机，均可通过浏览器直接访问91免费视频网站在线观看，无需下载任何插件或播放器。',
  },
  {
    q: '视频画质最高支持多少？',
    a: '平台最高支持4K超清画质播放，提供多档清晰度选项供用户根据网络情况自由切换。我们致力于打造高清视频网站免费观看的标杆体验，让每一个画面都清晰细腻。',
  },
  {
    q: '如何反馈问题或建议？',
    a: '您可以通过页面底部的联系方式或#contact区域的邮箱与我们取得联系，我们重视每一位用户的反馈，会在收到后尽快处理。您也可以关注#updates了解平台最新动态和功能更新。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100/80 text-accent-700 text-xs font-label font-semibold mb-4 whitespace-nowrap">
            常见问题
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
            常见问题解答
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            快速了解91免费视频网站的使用方法
          </p>
        </div>

        <div className="max-w-2xl mx-auto flex flex-col gap-3">
          {faqs.map((faq, idx) => (
            <div key={idx} className="rounded-xl bg-background-50 border border-background-200/60 overflow-hidden">
              <div className="p-5">
                <div className="flex items-start gap-3">
                  <span className="w-6 h-6 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 text-xs font-label font-bold shrink-0 mt-0.5">
                    Q
                  </span>
                  <div>
                    <h3 className="font-heading font-semibold text-sm text-foreground-900 mb-2">{faq.q}</h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}